// extracted by mini-css-extract-plugin
export default {"container":"opener_container__uINLW","small":"opener_small__Bu6QQ"};